import CustomVideoPlayer from "../../../../src/components/custom-video-player";
import ComponentLayout from "../../../../src/layouts/component-layout";
import centerAlignDo from "../../../../content/components/Card/images/cardstackedmaxdo.png";
import centerAlignDont from "../../../../content/components/Card/images/cardstackedmaxdont.png";
import * as React from 'react';
export default {
  CustomVideoPlayer,
  ComponentLayout,
  centerAlignDo,
  centerAlignDont,
  React
};